import React, { FC } from 'react';
import styled from 'styled-components';
import NotAssignComponent from '../NotAssign.component';
import { useTranslation } from 'react-i18next';

interface InternshipCommentBlockProps {
  comment: string;
}

const StyledInternshipCommentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  font-size: 12px;
  line-height: 14px;
  font-weight: 500;
`;

const StyledInternshipComment = styled.div`
  text-align: center;
  white-space: break-spaces;
`;

const StyledInternshipTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.colors.LABEL};
`;

const InternshipCommentBlock: FC<InternshipCommentBlockProps> = ({
  comment,
}) => {
  const { t } = useTranslation();

  return (
    <StyledInternshipCommentWrapper>
      <StyledInternshipTitle>{t('Comment')}</StyledInternshipTitle>
      <StyledInternshipComment>
        <NotAssignComponent has={!!comment}>{comment}</NotAssignComponent>
      </StyledInternshipComment>
    </StyledInternshipCommentWrapper>
  );
};

export default InternshipCommentBlock;
